<template>
  <b-nav class="p-0 my-0">
    <b-row align-v="center">
      <b-col
        cols="auto"
        class="py-0 font-weight-bold"
      >
        {{ title }}
      </b-col>
      <b-col
        cols="auto"
        class="px-0"
      >
        <i
          id="popover-header-info"
          class="fa fa-custom-x fa-info-circle text-info"
        />
        <b-popover
          target="popover-header-info"
          :placement="popOverPlacement"
          :title="title"
          triggers="hover focus"
        >
          <slot />
        </b-popover>
      </b-col>
    </b-row>
  </b-nav>
</template>

<script>

export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    popOverPlacement: {
      type: String,
      default: 'right'
    }
  }
}
</script>

<style lang="sass" scoped >
  .fa-custom-x
    font-size: 1.5em
  .dark-style
    background-color: black
    color: red
</style>



// WEBPACK FOOTER //
// src/app/shared/components/PageHeader.vue